import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { TOFU, SOY } from 'styles/theme/colors';
import { FONT_PRESET_MAP } from 'styles/theme/constants';

const StyledBox = styled(Box)(() => ({
  textAlign: 'center',
  margin: '24px 0 0',
  background: TOFU,
  padding: '8px 0'
}));

const StyledTypography = styled(Typography)({
  color: SOY,
  fontFamily: FONT_PRESET_MAP.circular_std_book
});

const HonestPricingLawBanner = ({ bannerFeeText }) => {
  return (
    <StyledBox>
      <StyledTypography data-testid="honest-pricing-law-message">
        {bannerFeeText}
      </StyledTypography>
    </StyledBox>
  );
};

HonestPricingLawBanner.propTypes = {
  bannerFeeText: PropTypes.string.isRequired
};

export default HonestPricingLawBanner;
